<template>
  <div>
    <v-tabs
      v-if="markets !== null"
      class="my-0"
      slider-color="transparent"
      :value="value"
      height="40"
      color="transparent"
      @change="input"
    >
      <v-tab
        v-for="(baseCurrencies, exchange) in markets"
        :key="exchange"
        ripple
        class="exchange-tab"
      >
        <img
          :src="'/img/' + exchange + '_logo.svg'"
          :alt="exchange"
          width="20"
          height="20"
        />
        {{ exchange }}
      </v-tab>

      <v-tabs-items touchless>
        <v-tab-item
          v-for="(baseCurrencies, exchange) in markets"
          :key="exchange"
        >
          <slot :exchange="exchange"></slot>
        </v-tab-item>
      </v-tabs-items>
    </v-tabs>
    <v-flex v-else class="xs12 md12 lg12 pl-0 pr-0">
      <v-card class="pa-32">
        <v-card-text class="no-profits">
          <h2 class="title mb-32 mt-3">
            Profits and unrealised losses
          </h2>
          <p>No profits yet.</p>
        </v-card-text>
      </v-card>
    </v-flex>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "ExchangeTabsDashboard",
  props: ["value"],
  methods: {
    input(val) {
      this.$emit("input", val);
    }
  },
  computed: {
    ...mapGetters({
      markets: "accountValue/tabsNamesForProfits",
    })
  }
};
</script>

<style scoped>
.pa-32 {
  padding: 32px;
}
>>> .theme--light h2 {
  color: #468aff;
}
>>> .theme--light p {
  color: #468aff;
}
>>> .theme--light .v-tabs__item {
  color: #468aff;
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  text-transform: uppercase;
}
.theme--light .no-profits {
  color: #103a84;
  font-family: "Lato", serif !important;
  padding: 0px;
}
>>> .v-tabs__item img {
  margin-right: 8px;
}
>>> .theme--dark.v-tabs__bar {
  background-color: #454547 !important;
}
>>> .theme--light .exchange-tab {
  background: rgba(255, 255, 255, 0.3);
  box-shadow: 4px 6px 20px rgba(57, 95, 169, 0.18);
  margin-right: 2px;
  border-radius: 10px 10px 0px 0px;
  min-width: 144px;
}
>>> .theme--light .exchange-tab a.v-tabs__item--active {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  text-transform: uppercase;
  color: #0051dd;
  background: #ffffff;
  box-shadow: 4px 6px 20px rgba(57, 95, 169, 0.18);
  border-radius: 10px 10px 0px 0px;
}

>>> .theme--light .v-tabs__wrapper {
  padding-top: 10px;
}

/*dark mode*/

>>> .theme--dark .v-tabs__item {
  color: #e9e9e9;
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  text-transform: uppercase;
}
.theme--dark .no-profits {
  color: #454547;
  font-family: "Lato", serif !important;
  padding: 0px;
}
>>> .theme--dark.v-tabs__bar {
  background-color: #303030 !important;
}
>>> .theme--dark .exchange-tab {
  background: #454547;
  box-shadow: 6px 4px 10px rgba(0, 0, 0, 0.25);
  margin-right: 2px;
  border-radius: 10px 10px 0px 0px;
  min-width: 144px;
}
>>> .theme--dark .exchange-tab a.v-tabs__item--active {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  text-transform: uppercase;
  color: #ffffff;
  background: #212121;
  border-radius: 10px 10px 0px 0px;
}
>>> .theme--dark .v-tabs__wrapper {
  padding-top: 10px;
}
>>> .theme--dark h2 {
  color: #ffffff;
}
>>> .theme--dark p {
  color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// resources/js/components/global/ExchangeTabsDashboard.vue